var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"Home"}},[_c('v-container',{attrs:{"fluid":""}},[_c('HomeALanding')],1),_c('HomeBAbout',{staticClass:"py-16"}),_c('HomeCVideo',{staticClass:"py-16"}),_c('HomeDServices',{staticClass:"py-16"}),_c('HomeESay',{staticClass:"py-16"}),_c('HomeFPosition',{staticClass:"py-16"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }